import { authClient } from '../lib/auth-client'

export class AuthService {
  async adminLogin(credentials: { email: string; password: string }) {
    const { data, error } = await authClient.signIn.email({
      email: credentials.email,
      password: credentials.password,
    })

    if (error) {
      throw new Error(error.message || 'Login failed')
    }

    return data
  }

  async mfaVerify(code: string) {
    const { data, error } = await authClient.twoFactor.verifyTotp({ code })

    if (error) {
      throw new Error(error.message || 'MFA verification failed')
    }

    return data
  }

  async employeeOtpRequest(phone: string) {
    const { error } = await authClient.phoneNumber.sendOtp({ phoneNumber: phone })

    if (error) {
      throw new Error(error.message || 'Failed to send OTP')
    }

    return { ok: true }
  }

  async employeeOtpVerify(phone: string, code: string) {
    const { data, error } = await authClient.phoneNumber.verify({
      phoneNumber: phone,
      code,
    })

    if (error) {
      throw new Error(error.message || 'OTP verification failed')
    }

    return data
  }

  async forgotPassword(email: string): Promise<{ ok: boolean }> {
    const redirectTo = `${window.location.origin}/auth/reset-password`
    const { error } = await authClient.requestPasswordReset({
      email,
      redirectTo,
    })

    if (error) {
      throw new Error(error.message || 'Failed to request password reset')
    }

    return { ok: true }
  }

  async resetPassword(token: string, newPassword: string): Promise<{ ok: boolean }> {
    const { error } = await authClient.resetPassword({
      token,
      newPassword,
    })

    if (error) {
      throw new Error(error.message || 'Failed to reset password')
    }

    return { ok: true }
  }

  async changePassword(
    currentPassword: string,
    newPassword: string
  ): Promise<{ ok: boolean }> {
    const { error } = await authClient.changePassword({
      currentPassword,
      newPassword,
      revokeOtherSessions: true,
    })

    if (error) {
      throw new Error(error.message || 'Failed to change password')
    }

    return { ok: true }
  }

  async logout(): Promise<{ ok: boolean }> {
    await authClient.signOut()
    return { ok: true }
  }

  async getSession() {
    const { data } = await authClient.getSession()
    return data
  }
}

export const authService = new AuthService()
